import { connect } from 'react-redux';
import { loginAction } from '@smorder/logic';
import Login from './login';

const mapDispatchToProps = dispatch => ({
  login: credentials => dispatch(loginAction.INIT(credentials)),
});

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
  inApp: state.app.inApp,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
